export function feedPath(post) {
  return `/feed/${encodeURIComponent(post.slug || String(post.id))}`;
}

export function feedDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  return match ? `${match[1]}.${Number(match[2])}.${Number(match[3])}` : value;
}
